import {
  AWS_BUCKET_URL,
  GATEWAY_API_KEY,
  GATEWAY_API_URL,
  LOYALTY_URL,
  STAFF_ATTENDANCE,
  INVENTORY,
  TOSSDOWN_SITE,
} from "config";
import { getLocalStorage } from "features/components/helperFunctions";

export const API_END_POINTS = {
  // get sidebar json
  getMenuJSON: { url: "/get_menu_json", method: "POST" },

  // AWS image upload url
  AWSImageUpload: { url: `${AWS_BUCKET_URL}images/upload`, method: "POST" },

  // favicon
  getFavicon: { url: `${TOSSDOWN_SITE}/get_favicon`, method: "POST" },
  saveFavicon: { url: `${TOSSDOWN_SITE}/save_favicon`, method: "POST" },

  // cart settings
  getCartSetting: { url: `${TOSSDOWN_SITE}/get_cart_on_off`, method: "GET" },
  updateCartSetting: { url: `${TOSSDOWN_SITE}/cart_on_off`, method: "POST" },

  getBusinessDetailsURL: {
    url: `${TOSSDOWN_SITE}/get_business_detail`,
    method: "GET",
  },

  // user profile
  getUserProfile: { url: "/get_eatout_manager_profile", method: "POST" },
  updateUserProfile: { url: "/update_eatout_manager_profile", method: "POST" },

  // products
  getProducts: { url: "/products", method: "GET" },
  getSingleProduct: { url: "/product_details", method: "GET" },
  addEditProduct: { url: "/add_menu_item_new", method: "POST" },
  deleteProduct: { url: "/delete_menu_item", method: "POST" },
  bulkUpdateProductStatus: { url: "/bulk_update_menu_status", method: "POST" },
  bulkProductBrandDisassociation: {
    url: "/brands_disassociation",
    method: "POST",
  },
  bulkProductBrandAssociation: {
    url: "/brands_association",
    method: "POST",
  },
  bulkProductCategoryAssociation: {
    url: "/category_association",
    method: "POST",
  },
  brandsList: {
    url: "/get_eatout_brands_display",
    method: "POST",
  },
  // reservations
  getReservations: { url: "/get_eatout_user_reservations", method: "POST" },
  addReservations: { url: "/app_save_res", method: "POST" },
  editReservations: { url: "/edit_eatout_reservation", method: "POST" },
  getReservationsTimeline: { url: "/get_reservation_timeline", method: "POST" },
  updateReservationStatus: {
    url: "/update_reservation_status",
    method: "POST",
  },

  // branch association
  updateProductBranch: { url: "/update_menu_item_new", method: "POST" },

  // sort items
  sortItems: { url: "/sort_items", method: "POST" },

  // option sets & attributes
  getOptionSetsOrAttributes: { url: "/get_option_sets", method: "POST" },

  // categories
  getCategories: { url: "/get_menu_item_category", method: "POST" },
  deleteCategoryImage: { url: "/delete_category_image", method: "POST" },
  sortCategories: { url: "/sort_category", method: "POST" },

  // get order statuses
  getOrderStatus: { url: "/get_eatout_order_status", method: "POST" },
  // Delivery Areas
  getDeliveryAreas: { url: "/get_order_delivery_areas", method: "post" },
  addUpdateDeleteDeliveryAreas: {
    url: "/add_order_delivery_areas",
    method: "post",
  },
  addDeliveryRanges: { url: "/add_delivery_ranges", method: "post" },
  getCountriesList: { url: "/get_countries", method: "get" },
  getCitiesList: { url: "/get_cities", method: "GET" },

  // google API url
  googleAPI: { url: "https://maps.googleapis.com/maps/api", method: "GET" },

  getAccessBranches: { url: `/get_eatout_branches`, method: "GET" },
  addBranchesLocations: { url: "/add_eatout_location", method: "POST" },
  editBranchesLocations: { url: "/edit_eatout_location", method: "POST" },
  deleteBranchesLocations: { url: "/delete_eatout_location", method: "POST" },
  pinBranchLocation: { url: "/add_location_map", method: "POST" },
  getBusinessDetails: { url: "get_eatout_details_new", method: "GET" },
  getProfileSettings: { url: "get_profile_settings", method: "GET" },
  editBusinessProfile: { url: "/edit_eatout_basic_profile", method: "POST" },

  // Users Module
  getUsers: { url: "/get_eatout_users", method: "post" },
  addUser: { url: "/add_eatout_user", method: "post" },
  editUser: { url: "/edit_eatout_user", method: "post" },
  disableUser: { url: "/disable_eatout_user", method: "post" },
  POSkeyGeneration: { url: "/send_verification_code", method: "post" },

  // cache
  clearCache: { url: "/purge_business_cached_data", method: "GET" },

  // menu settings
  getMenuOptions: { url: "/get_menu_options", method: "POST" },
  editMenuOptions: { url: "/edit_menu_options", method: "POST" },

  // reservation details settings
  getReservationDetails: { url: "/get_reservation_options", method: "POST" },
  updateReservationDetails: { url: "/add_reservation_options", method: "POST" },

  // reservation hours settings
  getReservationHours: { url: "/get_reservation_timings", method: "POST" },
  addReservationHours: { url: "/add_reservation_time_slot", method: "POST" },
  deleteReservationHours: {
    url: "/delete_reservation_time_slot",
    method: "POST",
  },

  // order options
  getOrderOptions: { url: "/get_order_options", method: "POST" },
  editOrderOptions: { url: "/add_order_options", method: "POST" },

  // order delivery options
  getOrderDeliveryOptions: {
    url: "/get_order_delivery_options",
    method: "POST",
  },
  addOrderDeliveryOptions: {
    url: "/add_order_delivery_options",
    method: "POST",
  },

  // reviews
  getReviews: { url: "/products_reviews_get", method: "get" },
  getBusinessReviews: { url: "/get_reviews", method: "get" },
  updateReviews: { url: "/update_review_status", method: "POST" },

  // website banners
  getBanner: { url: `${TOSSDOWN_SITE}/getBanner`, method: "POST" },
  addBanner: { url: `${TOSSDOWN_SITE}/addBanner`, method: "POST" },
  editBanner: { url: `${TOSSDOWN_SITE}/editBanner`, method: "POST" },
  deleteBanner: { url: `${TOSSDOWN_SITE}/deleteBanner`, method: "POST" },
  sortBanner: { url: `${TOSSDOWN_SITE}/sortBanner`, method: "POST" },

  // website ticker
  getTicker: { url: `${TOSSDOWN_SITE}/getTicker`, method: "POST" },
  updateTicker: { url: `${TOSSDOWN_SITE}/headerTicker`, method: "POST" },

  // website theme
  getWebsiteTheme: { url: `${TOSSDOWN_SITE}/get_theme_colors`, method: "POST" },
  updateWebsiteTheme: {
    url: `${TOSSDOWN_SITE}/save_theme_colors`,
    method: "POST",
  },

  // website popup
  getPopup: { url: `${TOSSDOWN_SITE}/getPopup`, method: "POST" },
  addPopup: { url: `${TOSSDOWN_SITE}/popupBanner`, method: "POST" },
  deletePopup: { url: `${TOSSDOWN_SITE}/deletePopup`, method: "POST" },

  // website static pages
  getStaticPages: { url: `${TOSSDOWN_SITE}/get_static_pages`, method: "POST" },
  saveStaticPages: { url: `${TOSSDOWN_SITE}/save_static_page`, method: "POST" },

  // staff attendance
  getStaffAttendance: {
    url: `${STAFF_ATTENDANCE}/get-attendance-report`,
    method: "GET",
  },

  // seo
  getPageSEO: { url: `${TOSSDOWN_SITE}/page_seo`, method: "POST" },
  editPageSEO: { url: `${TOSSDOWN_SITE}/edit_page_seo`, method: "POST" },

  // payment types settings
  getPaymentType: { url: `/get_payment_type`, method: "POST" },
  addPaymentType: { url: `/add_payment_type`, method: "POST" },
  editPaymentType: { url: `/edit_payment_type`, method: "POST" },
  deletePaymentType: { url: `/delete_payment_type`, method: "POST" },
  addPaymentTypeOption: { url: `/add_payment_option`, method: "POST" },
  editPaymentTypeOption: { url: `/edit_payment_option`, method: "POST" },
  deletePaymentTypeOption: { url: `/delete_payment_option`, method: "POST" },

  // business hours
  getBusinessHours: { url: "/get_business_hours", method: "GET" },
  updateBusinessHours: { url: "/update_business_hours", method: "POST" },

  // time bounded products
  getTimeBoundedProducts: {
    url: "/get_time_bound_deals",
    method: "POST",
  },
  updateTimeBoundedProducts: {
    url: "/update_time_bound_deals",
    method: "POST",
  },

  // email settings
  emailSettings: { url: "/branch_email_settings/" },

  // sms settings
  smsSettings: { url: "/branch_sms_settings/" },
  reservationSmsSettings: { url: "/reservation_sms_settings/" },

  // Orders
  getOrders: { url: "/order_get", method: "POST" },
  bulkStatusUpdate: { url: "/order_status_update", method: "POST" },
  orderPickupChange: {
    url: "/order_pickup_change",
    method: "post",
  },

  // order payments url
  bamboraPayment: `${TOSSDOWN_SITE}/td_pre_auth_confirm_payment`,
  stripePayment: `/stripe_subaccount/capture_payment`,

  // Get Subscriptions
  getSubscriptions: {
    url: `${process.env.REACT_APP_SUBSCRIPTIONS}/business`,
    method: "GET",
  },

  // Cancel Subscriptions
  cancelSubscriptions: {
    url: `${process.env.REACT_APP_SUBSCRIPTIONS}/unsubscribe-schedule`,
    method: "POST",
  },

  thirdPartyInventoryFetchAll: {
    url: "/third_party_inventory_update/fetch_all_dc",
    method: "POST",
  },

  thirdPartyInventoryPlaceOrder: {
    url: "/third_party_inventory_update/place_order",
    method: "POST",
  },
  // get Reports
  getReports: { url: "/reports_get", method: "GET" },
  // Integration API
  addDeliveryServices: {
    url: "/thirdparty_delivery_sms_integration",
    method: "post",
  },
  // Global Settings
  getGlobalSettings: { url: "/eatout_global_settings", method: "GET" },
  // connect google analytics
  connectGoogleAnalytics: { url: "/google_analytics_user_auth", method: "GET" },
  getGoogleAnalyticsProfiles: {
    url: "/get_google_analytics_profiles",
    method: "POST",
  },
  linkGoogleAnalyticsProfile: {
    url: "/link_analytics_profile_with_business",
    method: "POST",
  },
  getGoogleAnalyticsReports: {
    url: "/get_google_analytics_reports",
    method: "POST",
  },

  /* POS Reports */
  getPOSReportFilters: { url: "/reports_filters", method: "POST" },
  getPOSSaleSummary: { url: "/pos_sales_summary", method: "POST" },
  getPOSCashSummary: { url: "/cash_drawer_summary", method: "POST" },
  houseAccountAPI: { url: "/report_listing", method: "POST" },
  // Bulk Upload
  getBlukImage: { url: "/get_eatout_images", method: "GET" },
  bulkDeleteImage: { url: "/bulk_delete_eatout_image", method: "POST" },
  bulkLinkEatOutImage: { url: "/bulk_link_eatout_image", method: "POST" },

  // Loyalty Program
  allCampaignsList: {
    url: `${LOYALTY_URL}/campaign/all/business/${
      getLocalStorage()?.eatout_id || 0
    }`,
    method: "GET",
  },
  createLoyaltyCampaign: {
    url: `${LOYALTY_URL}/campaign`,
    method: "POST",
  },
  getCouponReport: {
    url: `${LOYALTY_URL}/activity/business`,
    method: "GET",
  },

  // customers
  getCustomers: {
    url: `${GATEWAY_API_URL}/businesses`,
    method: "GET",
    headers: { "x-api-key": `${GATEWAY_API_KEY}` },
  },

  // Custom reports
  getOrderCustomReport: { url: "/get_orders_custom_report", method: "POST" },
  deleteCustomReport: { url: "/disable_orders_custom_report", method: "POST" },
  saveCustomReport: { url: "/save_orders_custom_report", method: "POST" },

  // Rider Dashboard
  getRiderStats: { url: "/rider_reports_get", method: "POST" },

  // Inventory --
  // Suppliers
  getSuppliers: { url: `${INVENTORY}/SupplierGet`, method: "POST" },
  addSuppliers: { url: `${INVENTORY}/SupplierAdd`, method: "POST" },
  updateSuppliers: { url: `${INVENTORY}/SupplierUpdate`, method: "POST" },
  deleteSuppliers: { url: `${INVENTORY}/SupplierDelete`, method: "POST" },

  // Stocks
  getStockList: { url: `${INVENTORY}/InventoryGet`, method: "POST" },
  addStock: { url: `${INVENTORY}/StockAdd`, method: "POST" },

  // Purchase Order
  getPurchaseOrders: { url: `${INVENTORY}/StockGet`, method: "POST" },
  updatePurchaseOrders: { url: `${INVENTORY}/StockUpdate`, method: "POST" },

  // Billing Details
  billingDetails: {
    url: `${TOSSDOWN_SITE}/get_billing_details`,
    method: "GET",
  },
  // billingDetails: { url: `https:staging.tossdown.site/api/get_billing_details`, method: "GET"},
  subscriptionPlan: {
    url: `https://static.tossdown.com/system_config/subscription.json`,
    method: "GET",
  },
};
